import { Component, OnInit } from '@angular/core';
import { Util } from '../core-utilities/Util';
import { UserProfileSettingsService } from '../system-services/UserProfileSettings/UserProfileSettings.service';
import { TranslationService } from '../translations/Translation.service';

type DropdownItem = {
    onClick: Function;
    text: string;
};

@Component({
    selector: 'pi-translation-dropdown',
    template: `
        @if (TR.translationModeOn) {
            <pi-dropdown
                [list]="dropdownList"
                [placeholder]="TR.key('translation.selectTranslationMode')"
                (onSelected)="dropdownClick($event)"
                [direction]="{ horizontal: 'left', vertical: 'bottom' }"
            >
                <ng-template let-item="item">{{ item.text }}</ng-template>
            </pi-dropdown>
        }
    `,
    standalone: false
})
export class TranslationDropdownComponent implements OnInit {
    dropdownList: DropdownItem[] = [];

    constructor(
        public TR: TranslationService,
        public userProfileService: UserProfileSettingsService,
        private util: Util
    ) {}

    ngOnInit() {
        this.dropdownList = [
            {
                text: this.TR.key('translation.normalMode'),
                onClick: () => this.TR.setTranslationMode('Normal')
            },
            {
                text: this.TR.key('translation.hashMode'),
                onClick: () => this.TR.setTranslationMode('Hash')
            },
            {
                text: this.TR.key('translation.encloseMode'),
                onClick: () => this.TR.setTranslationMode('Enclose')
            },
            {
                text: this.TR.key('translation.keyMode'),
                onClick: () => this.TR.setTranslationMode('Key')
            },
            {
                text: this.TR.key('translation.goToEnglish'),
                onClick: () =>
                    this.util.queryString.setAndReload([
                        {
                            key: 'languageLocale',
                            value: 'en-US'
                        }
                    ])
            }
        ];
    }

    dropdownClick(item: DropdownItem): void {
        item.onClick();
    }
}
